import { Component, OnInit, Input } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { LookupService } from "app/webservice/lookup.service";
import { ActivatedRoute, Router } from "@angular/router/";
import { ToastsManager } from "ng2-toastr";
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { MediaService } from 'app/media/media.service';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class MediaComponent implements OnInit {

  @Input() id: number;

  public serviceStackUrl;
  public mediaInfo = {};
  public events = [];
  public categories = [];
  public statuses = [];
  public series = [];
  public assetType = '';
  public assetTypes = [];

  constructor(
    private _mediaService: MediaService,
    private _restService: RestService,
    private _toast: ToastsManager,
    private route: ActivatedRoute,
    private router: Router,
    private _lookup: LookupService,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this._mediaService.selectedAsset.subscribe(asset => {
      if (Object.keys(asset).length !== 0) {
        this.assetType = asset.AssetType;
        this.mediaInfo = asset;
        console.log(this.mediaInfo);
      } else {
        let oid = this.route.snapshot.params['Oid'];
        this.getAssetByOid(oid);
      }
    });

    this.events = this._lookup.findLookupByLookupName('Event');
    this.categories = this._lookup.findLookupByLookupName('AssetCategory');
    this.statuses = this._lookup.findLookupByLookupName('AssetStatus');
    this.series = this._lookup.findLookupByLookupName('Series');
    this.assetTypes = this._lookup.findLookupByLookupName('AssetType');
  }

  ngOnInit() {

  }

  selectAsset(oid) {
    console.log(oid);
    /*if (this.mediaInfo['lkpAssetTypeOidList'].indexOf(oid) > -1) {
      this.mediaInfo['lkpAssetTypeOidList'].splice(this.mediaInfo['lkpAssetTypeOidList'].indexOf(oid), 1);
    } else {
      this.mediaInfo['lkpAssetTypeOidList'].push(oid);
    }*/
  }

  getAssetByOid(oid) {
    let url = this.serviceStackUrl + "Asset-QuickSearch";
    this._restService.post(url, {Oid: oid}).then(response => {
      console.log(response);
      this.assetType = response.Asset.AssetType;
      this.mediaInfo = response.Asset;
      console.log(this.mediaInfo);
    })
  }

  saveAsset() {
    let url = this.serviceStackUrl + "Asset-AddEditAsset";
    console.log(this.mediaInfo);
    this._restService.post(url, {Asset: this.mediaInfo}).then(response => {
      console.log(response);
      if (response.Asset) {
        this._toast.success('Successfully updated ' + response.Asset.Title);
      } else {
        this._toast.error('Failed to update ' + + response.Asset.Title);
      }
    })
  }

  cancelEdit() {
    this.router.navigate(['/media/search']);
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/media/media.component.ts